// ZH content — 全量页面文案（合规翻译版）。
// 键名与 src/content/en.js 完全一致，不新增、不删减字段。
// `assumed()` 与 `entity` 复用 en.js 的单一来源，避免两套「待确认假设」台账漂移。
// 合规约束（继承 05-brand-message-contract §4.3/§8）：不出现基金管理人/投资基金/
// 金融产品建议（作为我方服务）/面向公众募资/保证收益/proven/big data/AI-driven/
// proprietary data/未授权客户名/具名第三方数据源；数字仅以范围+出处出现。
import { entity, assumed } from './en';

const zh = {
  entity,

  nav: {
    aria: '主导航',
    home: '首页',
    whatWeInvest: '我们投资什么',
    howWeInvest: '我们如何投资',
    about: '关于我们',
    contact: '联系',
    submitCta: '提交合作机会',
    pillars: {
      property: { label: '房地产开发', desc: '土地与开发机会。' },
      built: { label: '建成环境产业投资', desc: '构建与塑造建成环境的企业。' },
      innovation: { label: '创新与创投', desc: '地产科技、建造科技、人工智能与可持续建造。' },
    },
    language: { en: 'EN', zh: '中文', current: '中文', toggle: 'EN' },
  },

  footer: {
    entityTitle: '主体',
    navTitle: '导航',
    legalTitle: '法律',
    ctaTitle: '提交合作机会',
    ackTitle: '原住民土地致意',
    country:
      'Cyberate Investments 向全澳原住民土地的传统所有者与守护者致敬。我们向过去与现在的长者致敬，并尊重原住民与托雷斯海峡岛民人民延续至今的文化、精神与教育实践。',
    copyright: '© {{year}} Cyberate Investments Pty Ltd. 版权所有。',
  },

  cta: {
    submit: '提交合作机会',
    submitCommit:
      '请告诉我们您机会的类型、地点与阶段。我们会回复后续步骤，而非出资承诺。',
    discuss: '洽谈合作',
    discussCommit: '适用于尚无具体待评估机会的一般或战略性沟通。',
    explore: '了解我们投资的方向',
    seeCriteria: '查看标准',
    seeApproach: '查看完整方法',
    backToHome: '返回首页',
  },

  ui: {
    privacyPolicy: '隐私政策',
    terms: '条款与条件',
    sending: '发送中…',
    submitting: '提交中…',
    pending: '待核实',
    evidencePending: '证据待核实',
    onThisPage: '本页目录',
    skipExpired: '安全校验已过期——请重新完成。',
    captchaNote: '此验证由 hCaptcha 提供，并受其隐私政策约束。',
    toggleMenu: '打开菜单',
    closeMenu: '关闭菜单',
    skipToContent: '跳至正文',
    logoHome: 'Cyberate Investments — 首页',
    optional: '（选填）',
    labels: {
      entity: '实体',
      address: '地址',
      phone: '电话',
      email: '邮箱',
      controller: '控制者',
      updated: '更新日期',
      effective: '生效日期',
    },
    stage: {
      io: '您 / 我们提供：',
      input: '输入：',
      role: '我们的角色：',
      continue: '继续的条件：',
      stop: '停止的条件：',
      note: '说明：',
    },
    byPillar: {
      input: '主要输入：',
      risk: '关键风险：',
      value: '价值重心：',
      material: '首次提交：',
    },
    cols: {
      dim: '维度',
      what: '我们看什么',
      why: '原因',
      role: '角色',
      when: '适用情形',
      responsibility: '责任',
      notMeaning: '并不意味着',
      face: '视角',
      input: '所需输入',
      evidence: '所需证据',
      impact: '对决策的影响',
      point: '我们问什么',
      detail: '我们的立场',
      whyMatters: '为何重要',
      consider: '我们考虑什么',
      verify: '如何核实',
      theme: '主题',
      preference: '通常偏好',
      variable: '视情形而定',
      area: '领域',
      inputShort: '输入',
      action: '可能采取的行动',
      measure: '如何衡量',
      problem: '行业问题',
      tech: '技术示例',
      result: '可衡量的结果',
      stage: '阶段',
      evidenceExpected: '预期证据',
      invest: '投资',
      pilot: '试点 / 协作',
      evidenceExamples: '证据示例',
      path: '路径',
      precondition: '前提条件',
      cyRole: 'Cyberate 角色',
      notPromise: '我们不承诺',
      gate: '门槛',
      pass: '通过信号',
      stop: '停止信号',
      party: '一方',
      responsible: '通常负责',
      decisions: '决策',
      notResponsible: '不负责',
      cap: '能力',
      behaviour: '可观察的行为',
      allowedEvidence: '可接受的证据',
      forbidden: '不接受',
      risk: '风险类别',
      control: '控制',
      escalate: '升级 / 停止',
      scenario: '情形',
      dataCategories: '数据类别',
      source: '来源',
      required: '是否必需',
      purpose: '目的',
      data: '数据',
      basis: '依据',
      consequence: '如未提供',
      recipient: '接收方',
      location: '地点',
      safeguard: '保障措施',
      recordType: '记录类型',
      term: '期限 / 标准',
      right: '权利',
      how: '如何行使',
      limit: '限制',
      practice: '我们做什么',
      howShows: '在本网站上如何体现',
    },
  },

  compliance: {
    short:
      'Cyberate Investments Pty Ltd 是一家位于阿德莱德的开发与投资公司。本网站仅提供一般信息，不构成金融产品建议、任何金融产品的要约，也不构成投资招揽。每个机会均需经过评估，参与方式与条款均逐项单独约定。凡引用过往表现之处，均不保证未来结果。',
    full:
      'Cyberate Investments Pty Ltd 是一家位于阿德莱德的开发与投资公司。本网站的任何内容均不构成金融产品建议、推荐、获取任何金融产品的要约或邀请，也不构成对任何回报或结果的承诺。我们描述我们专注的机会以及我们可能扮演的角色，但参与、资本、结构与条款仅在评估之后、并在必要时经法律与监管审查后，针对具体机会逐项约定。我们不面向公众募资，也不向零售客户提供个人金融建议。本网站上的任何数字均标明其范围、依据、期间与来源；历史信息不保证未来结果。',
    companyCategory: assumed('final company category and AFS / licensing boundary'),
  },

  home: {
    meta: {
      title: 'Cyberate Investments — 阿德莱德房地产开发与投资公司',
      description:
        'Cyberate Investments 是一家位于阿德莱德的开发与投资公司，专注于地产、建成环境企业与推动创新。我们评估精选机会，并在适当情况下参与。',
    },
    hero: {
      eyebrow: '阿德莱德',
      h1: '我们投资塑造建成环境的地产、企业与创意。',
      lead:
        'Cyberate Investments 是一家位于阿德莱德的开发与投资公司。我们专注于房地产开发、建成环境企业与推动创新。我们依据明确的标准、可核实的证据，以及我们能够清晰承担的角色来评估每个机会。',
      kicker:
        '每个决策都用同一套视角：多因子输入，每项都带来源与日期，在承担角色之前先经受压力检验。',
      boundary:
        '每个机会均单独评估。参与方式与条款逐项约定；此处内容不构成任何金融产品的要约，也不构成回报承诺。',
    },
    pillars: {
      eyebrow: '我们投资什么',
      h2: '我们专注的三个领域',
      lead: '每个领域都有自己的标准。选择与您情况最匹配的一项——联系我们之前，您可先查看详情。',
      boundary: '这些是我们专注的领域，而非过往交易的记录。',
      items: [
        {
          short: '地产',
          title: '房地产开发',
          desc: '南澳大利亚的土地与开发机会。',
          question: '您有地块或项目，想了解是否符合吗？',
          cta: '查看地产标准',
          to: '/property-development',
        },
        {
          short: '企业',
          title: '建成环境产业投资',
          desc: '建筑、工程、设计、供应链与专业服务企业。',
          question: '您是正在考虑增长、交接或战略合作伙伴的企业主吗？',
          cta: '查看业务标准',
          to: '/built-environment-investments',
        },
        {
          short: '创新',
          title: '创新与创投',
          desc: '地产科技、建造科技、人工智能与可持续建造团队。',
          question: '您的技术是否解决了可量化的建成环境问题？',
          cta: '查看创新标准',
          to: '/innovation-ventures',
        },
      ],
    },
    stance: {
      eyebrow: '我们的纪律',
      h2: '我们如何决策——以及何时停止',
      lead: '我们宁愿放弃一个机会，也不愿误述我们能对它做什么。',
      principles: [
        { title: '在追求什么上保持克制。', body: '我们在热情占据主导之前就设定标准，并在证据不足时停止。' },
        { title: '在创造价值上保持主动。', body: '在我们参与之处，我们带来与约定角色相称的结构、判断与执行支持。' },
        { title: '对风险与角色保持清晰。', body: '我们说明我们会评估什么、可能贡献什么，以及我们的责任止于何处。' },
      ],
      cta: '查看共同门槛与停止条件',
      stops: {
        h3: '什么会让我们停止',
        lead:
          '这些是我们停止的条件。我们将它们公开，以便您在联系我们之前，可以先自行检验匹配度。',
        items: [
          {
            title: '无法溯源的数字',
            body: '没有来源与日期的数字，无法通过证据门槛。这一点适用于每个阶段与每个领域。',
          },
          {
            title: '悬而未决的规划路径',
            body: '未解决的规划风险会终止评估。我们不会把它当作假设继续推进。',
          },
          {
            title: '仅在最佳情形下成立的案例',
            body: '我们在承诺之前会调整假设。如果案例在压力下站不住脚，我们就停止。',
          },
          {
            title: '我们无力承担的角色',
            body: '我们宁愿拒绝，也不承担自己无法承担的责任，或暗示自己并未约定的角色。',
          },
          {
            title: '我们不愿作出的主张',
            body: '每项能力都公布在其拒绝作出的主张旁边，包括我们无法演示的任何技术主张。',
          },
        ],
        note: '如果某个地产机会不在我们的标准之内，我们也会单独说明。',
        notFitLink: '查看我们在地产领域不追求什么',
      },
    },
    role: {
      h2: '我们如何帮助创造价值',
      lead: '我们的角色针对每个机会单独界定。它可能涉及以下一项或多项。',
      groups: [
        { title: '判断', body: '评估计划、市场、可行性，以及决定该案例是否应继续推进的风险。' },
        { title: '结构与参与', body: '商定参与形式，可能包括资本、共同投资或针对具体机会的支持。' },
        { title: '执行支持', body: '在约定角色范围内，支持规划、项目或运营工作。' },
      ],
      note: '每项能力都与其背后的证据挂钩。角色及其边界在工作开始之前就已约定。',
      cta: '查看角色如何界定',
    },
    connection: {
      eyebrow: '三者如何相连',
      h2: '同一个建成环境，三个切入点',
      lead: '同一类决策，落在三个点上：建造什么、由谁建造、用什么建造。',
      rows: [
        {
          node: '建造什么',
          pair: '地产与交付它的企业',
          link: '一个开发项目取决于设计、供应与建造它的企业。我们读懂其中一方，会有助于我们读懂另一方。',
        },
        {
          node: '由谁建造',
          pair: '企业与它们采用的工具',
          link: '只有当工具契合这些企业现有的工作方式时，它才可部署。运营者能告诉我们演示无法说明的东西。',
        },
        {
          node: '用什么建造',
          pair: '创新与它所落地的场景',
          link: '开发项目正是建成环境技术在真实条件下要么站得住、要么站不住的地方。',
        },
      ],
      boundary:
        '这些是相互关联的判断领域，而非打包的一揽子要约。每个机会都按其自身标准评估，在一个领域扮演角色，并不意味着在其它领域也有任何角色。',
      cta: '查看同一套方法如何适用于每个领域',
    },
    local: {
      eyebrow: '阿德莱德基地',
      h2: '一家可以核实的阿德莱德公司',
      boundary: '公司注册信息以及任何牌照或授权状态，均公布在我们的「关于我们」页面。',
      aboutLink: '查看公司信息',
    },
    preview: {
      eyebrow: '我们如何投资',
      h2: '五个阶段，每个阶段都有进入与退出',
      body: '识别 → 投资 → 建设 → 扩张 → 实现。每个阶段都有各自的输入、判断、我们的角色，以及我们停止的条件。',
      lens: '判断本身是标准化的：每个机会都通过相同的六个门槛——其中包括阻止无法核实的数字或缺失依据的那一个——而开发项目则通过相同的七因子视角来解读。',
      lensGate: '查看共同门槛与停止条件',
      lensProperty: '查看七因子开发视角',
      note: '阶段可以跳过、退回或停止。我们不会在每个项目中承担所有角色。',
      cta: '阅读完整方法',
      stages: ['识别', '投资', '建设', '扩张', '实现'],
    },
    finalCta: {
      h2: '有具体机会，还是仍在权衡？',
      body: '提交地块、企业或项目，供我们作首次判断。若仍在权衡，先看方法，或发送一般性问题。',
      review: '查看我们的方法',
      contact: '联系我们',
      privacy: '我们只收集首次评估所需的信息。',
    },
  },

  property: {
    meta: {
      title: '房地产开发 | Cyberate Investments',
      description:
        '我们如何评估南澳大利亚的房地产开发机会——地点、用途、阶段、规模、控制与规划——以及从资本到执行支持我们可能扮演的角色。',
    },
    hero: {
      eyebrow: '房地产开发',
      h1: '我们评估南澳大利亚的土地与开发机会。',
      lead:
        '如果您有地块或项目，请从决定决策的事实入手：地点、控制、规划状态、市场证据、可行性与交付风险。本页面说明我们评估什么、可能扮演的角色，以及提交前需要准备什么。',
      kicker: '地点、控制、规划状态、市场证据、可行性与交付风险——我们从这些事实入手。',
      boundary: '我们只看精选机会。地点、用途、阶段、规模与控制都很重要，每个机会都单独评估。',
      cta: '提交地产机会',
      seeCriteria: '查看标准',
      roleNote: '本页面任何内容都不构成融资要约，也不构成获批承诺。',
    },
    fit: {
      h2: '提交前我们关注什么',
      lead: '这些是我们评估的维度。已确认的门槛会列明；尚未确定的任何内容都会被标注，而非隐藏在「灵活」之后。',
      rows: [
        { dim: '地点', what: assumed('investment area / postcode / radius'), why: '我们专注于能够自行评估市场与规划风险的区域。' },
        { dim: '用途 / 资产类型', what: assumed('allowed use / asset types'), why: '用途决定可行性、买家与退出。' },
        { dim: '阶段', what: assumed('accepted stage — uncontrolled / controlled land / pre-planning / in approval / under construction'), why: '阶段决定我们需要何种证据。' },
        { dim: '规模', what: assumed('typical scale range and basis'), why: '规模必须契合我们的参与模式。' },
        { dim: '控制 / 产权', what: assumed('title and control requirements'), why: '我们需要知道谁能对该地块作出承诺。' },
        { dim: '规划状态', what: assumed('planning status requirements'), why: '规划风险是门槛，而非脚注。' },
        { dim: '时间线', what: assumed('expected timeline'), why: '时机影响结构与退出。' },
      ],
      note: '如果其中大多数尚不明确，先从您已知的信息开始——我们的表单只索取最低限度信息，而「尚不清楚」也是可接受的答案。',
      prepareLink: '准备提交',
    },
    notFit: {
      h2: '我们不接手什么',
      lead: '尽早说不，能为双方节省时间。除非我们的授权范围发生变化，否则以下内容均不在范围内。',
      items: [
        { title: '个人或零售投资建议', body: '我们不提供金融建议，也不管理任何人的投资组合。' },
        { title: '融资保证', body: '我们无法就任何项目保证获批、出资或完工。' },
        { title: '缺乏控制或产权无法核实的机会', body: '没有清晰的产权或授权，我们无法评估该承诺。' },
        { title: '超出我们重点区域的地块', body: assumed('out-of-area exclusion wording') },
        { title: '不足以评估的信息', body: '一份没有地点、阶段或所有权细节的简介，无法被评估。' },
      ],
      boundary: '我们能扮演的角色取决于机会本身以及适用的法律与监管边界。如果我们只能提供分析而非资本，我们会尽早告知。',
      alt: '不合适？一般性问题仍可发送至我们的联系页面。',
    },
    roles: {
      h2: '我们可能扮演的角色',
      lead: '角色针对每个机会单独约定——它不是一套打包方案。下表说明每个角色的含义以及它不代表什么。',
      rows: [
        { role: '资本参与', when: assumed('own capital / co-investment structure and conditions'), responsibility: '评估后针对具体机会约定的资本。', notMeaning: '出资承诺，或面向公众募资。' },
        { role: '共同投资 / 合资', when: assumed('JV structure and conditions'), responsibility: '具有明确决策权的共享结构。', notMeaning: '沉默资本或保证。' },
        { role: '开发 / 分析支持', when: '可行性、规划与结构问题。', responsibility: '在约定范围内的结构化评估与执行支持。', notMeaning: '牌照、获批或融资结果。' },
        { role: '项目执行支持', when: '当执行支持契合该角色时。', responsibility: '在约定责任范围内的规划与交付支持。', notMeaning: '承担所有职能的「一站式」交付。' },
      ],
      note: '角色仅在评估之后、并在必要时经法律与监管审查后确认。',
      methodLink: '角色如何界定',
    },
    assessment: {
      eyebrow: '评估视角',
      h2: '评估开发项目时我们权衡什么',
      lead: '我们把规划、市场、设计、可行性、资本、交付与风险视为一个整体决策——而非一列互不相干的复选框。',
      rows: [
        { face: '规划', gate: true, input: '分区、覆盖区、许可、条件。', evidence: '来自政府或法定公开来源的规划事实。', impact: '一项门槛：未解决的规划风险会终止评估。' },
        { face: '市场', input: '带来源与日期的可比销售与需求数据。', evidence: { lead: '带来源与日期', rest: '仅使用经许可、带日期的市场数据。' }, impact: '驱动用途与可行性假设。' },
        { face: '设计 / 产品', input: '地块约束与目标买家或租户。', evidence: '地块约束以及明确指定的目标买家或租户。', impact: '决定产品是否可信。' },
        { face: '可行性', input: '带依据的成本、收入与时机假设。', evidence: { lead: '带依据', rest: '假设经受压力检验。' }, impact: '检验计划在压力下是否成立。' },
        { face: '资本', input: '资本的结构、成本与来源。', evidence: '结构、成本与来源均已说明。', impact: '决定参与是否契合我们的模式。' },
        { face: '交付', input: '承建商、进度计划与交付记录。', evidence: '承建商身份、进度计划与交付记录。', impact: '检验执行风险是否可控。' },
        { face: '风险', input: '假设、敏感性与缓释措施。', evidence: { lead: '敏感性', rest: '假设已调整、缓释已说明。' }, impact: '决定推进与否，以及我们需要控制什么。' },
      ],
      lens: '这套七因子视角是我们解读开发项目的方式。它是我们自己的评估方法，而非行业标准，我们用它来决定我们自身的角色。',
      gateNote: '在角色约定之前，每个开发项目都通过相同的六个门槛——包括阻止无法核实的数字或缺失依据的那一个。',
      gateLink: '查看共同门槛与停止条件',
      cta: '查看这如何契合我们的五个阶段',
    },
    materials: {
      h2: '提交前需要准备什么',
      lead: '您无需一个完整的数据室。先从一个简短摘要开始；其余内容可随后通过安全渠道跟进。',
      minimum: [
        '地点与地块描述',
        '您对该地块的产权或授权',
        '当前阶段（规划、已获批、建设中）',
        '拟议用途与规模',
        '规划状态及任何许可',
        '预期时间线',
        '您希望从我们这里得到什么（资本、共同投资、评估、执行支持）',
      ],
      minimumTitle: '最低应包含',
      laterTitle: '可稍后提供',
      later: ['可行性模型或成本计划', '场地勘测、图纸、工程报告', '融资或销售证据'],
      privacy: '第一步请勿发送身份证明文件或无关的个人数据。文件上传（如可用）仅限表单上说明的格式与大小。',
      cta: '开始提交',
    },
    intermediaries: {
      h2: '如果您是代他人提交地块',
      lead:
        '代理人、顾问及其它中介均可提交。我们需要的是，在双方投入时间之前，以书面形式明确授权与利益关系。',
      rows: [
        {
          point: '您代表谁',
          detail: assumed('acceptance of agents / advisers'),
          why: '在评估任何内容之前，我们需要知道这是谁的决定。',
        },
        {
          point: '您持有何种授权',
          detail: assumed('title and control requirements'),
          why: '一个没有任何人能作出承诺的机会，无法通过角色匹配门槛。',
        },
        {
          point: '您持有何种利益',
          detail: assumed('intermediary policy'),
          why: '未披露的利益，是我们日后才发现的冲突——而日后发现更糟。',
        },
        {
          point: '费用如何运作',
          detail: assumed('intermediary / commission policy'),
          why: '这样就不会出现从未约定的费用预期。',
        },
      ],
      note: '首次接触时无需全部正式化。一句关于您代表谁、基于何种依据的简短说明，就足以启动。',
      cta: '查看我们如何处理冲突',
    },
    path: {
      h2: '提交之后会发生什么',
      lead: '四个步骤，每个都有明确的停止点。此处的任何阶段都不构成继续、出资或获批的承诺。',
      steps: [
        { title: '初步筛选', body: '我们依据标准检查地点、用途、阶段、规模与控制。', io: '您提供摘要；我们给出初步判断。' },
        { title: '信息与评估', body: '我们索取所需细节，并评估规划、市场、可行性与风险。', io: '您通过安全渠道提供文件。' },
        { title: '角色与条款', body: '我们讨论可能适用的角色、结构与条款。', io: '双方决定条款是否合适。' },
        { title: '推进或停止', body: '我们要么进入正式协议，要么停止并说明原因。', io: '任何一方都可在任一阶段停止。' },
      ],
      note: '保密协议、现场考察与第三方尽职调查，仅在机会需要时才引入。',
      cta: '查看完整方法',
    },
    faq: {
      h2: '提交前的常见问题',
      items: [
        { q: '提交前我需要取得规划批准吗？', a: '不需要。我们会看待不同阶段的机会。重要的是，您能描述该地块、其规划状态，以及您希望从我们这里得到什么。' },
        { q: '我需要完全拥有该土地吗？', a: '不需要——但您需要对其拥有授权。请告诉我们您是拥有它、已签约控制它，还是代表拥有它的人。 ' + assumed('acceptance of agents / advisers') },
        { q: '你们接受代理人或顾问的介绍吗？', a: '接受，前提是提交人拥有这样做的授权。我们会请您确认这一点。 ' + assumed('intermediary policy') },
        { q: '你们能保证出资或获批吗？', a: '不能。我们不保证融资、获批、完工或任何回报。我们扮演的任何角色都仅在评估之后约定。' },
        { q: '我的信息如何处理？', a: '我们只收集首次评估所需的信息。关于我们收集什么、为什么收集以及保留多久，请参阅我们的隐私政策。' },
      ],
      cta: '提交地产机会',
      alt: '改为联系我们',
      siblings: [
        { label: '建成环境产业投资', to: '/built-environment-investments' },
        { label: '创新与创投', to: '/innovation-ventures' },
      ],
    },
  },

  built: {
    meta: {
      title: '建成环境产业投资 | Cyberate Investments',
      description:
        '我们如何看待建筑、工程、设计、供应链与专业服务企业的投资——我们考虑的情形、结构与治理。',
    },
    hero: {
      eyebrow: '建成环境产业投资',
      h1: '我们关注构建与塑造建成环境的企业。',
      lead:
        '这里讲的是运营中的企业，而非地产项目。如果您拥有或经营一家建筑、工程、设计、供应链或专业服务企业，我们会查看其客户、交付、利润率、人员与增长计划背后的证据。本页面说明我们考虑的情形、可能扮演的角色以及我们需要什么。',
      kicker: '我们看的是经营中的企业，而不是地产项目——客户、交付、利润、团队与增长计划。',
      boundary: '我们寻求评估精选机会。这是一个明确的重点，而非已完成收购的记录，也不是全国性网络。 ' + assumed('whether this pillar is operational, geography and deal type'),
      cta: '提交业务机会',
      seeCriteria: '查看我们关注什么',
      roleNote: '我们不是企业经纪人、放贷方，也不是纯粹顾问。我们扮演的角色针对每个机会单独约定。',
    },
    focus: {
      h2: '我们专注的领域',
      lead: '这些是我们考虑的子行业与企业特征。已确认的门槛会列明；尚未确定的任何内容都会被标注。',
      sectors: [
        { title: '建筑与建造服务', body: '以重复性项目工作与交付能力为核心的企业。' },
        { title: '工程与设计', body: '技术能力与可复制的服务模式至关重要的企业。' },
        { title: '材料与设备供应', body: '供应链地位与利润率纪律驱动价值的企业。' },
        { title: '专业服务', body: '以客户关系与专业专长为核心资产的企业。' },
      ],
      traits: [
        { dim: '客户基础', what: assumed('client concentration and quality requirements'), verify: '企业客户名单与重复收入，并识别出集中度风险。' },
        { dim: '能力与人员', what: assumed('team / key-technology dependency requirements'), verify: '管理团队、文档化的交付流程，且不存在无人管理的对单一个人、牌照或系统的依赖。' },
        { dim: '项目敞口', what: assumed('project concentration and volatility tolerance'), verify: '在手项目、利润率与单一项目敞口，对照下行情景展示。' },
        { dim: '增长阶段', what: assumed('accepted business stage'), verify: '持续或可复制的收入历史；无收入概念与困境重整不在关注范围。' },
        { dim: '财务门槛', what: assumed('revenue / profit / geography / ownership thresholds'), verify: '企业财务报表，以及通向可持续正盈利的路径。' },
      ],
      traitsTitle: '企业特征',
      gateNote: '在角色约定之前，每家企业都通过相同的六个门槛——包括阻止无法核实的数字或缺失依据的那一个。',
      gateLink: '查看共同门槛与停止条件',
      note: '如果您的业务接近但不完全落入此范围，请提交一份简短摘要——我们会尽早告知它是否超出范围。',
    },
    notFit: {
      h2: '我们不追求什么',
      lead:
        '把这一点公开，比您在三轮对话之后才发现要省时得多。如果您的业务落在此处，我们不是合适的对象——而尽早说明，正是重点所在。',
      items: [
        {
          title: '没有交易记录的企业',
          body: '无收入的概念应归于创新领域，而非此处。这一领域读取的是成熟的运营。',
        },
        {
          title: '困境重整',
          body: '拯救一家经营不善的企业，与支持一家正常运转的企业，是两门不同的学问，而我们并不掌握前者。',
        },
        {
          title: '放贷',
          body: '我们不提供企业贷款。涉及资本之处，是股权或针对该机会的项目特定结构。',
        },
        {
          title: '建成环境之外的企业',
          body: '如果您的业务与建筑和场所的设计、供应、建造或运营毫无关联，我们就没有有用的判断可补充。',
        },
        {
          title: '价格是唯一问题的出售',
          body: '如果决策最终归结为当天出价最高者，经纪人会比我们更能帮到您。',
        },
      ],
      boundary: assumed('accepted business stage'),
      dealBoundary: assumed('deal-type boundary'),
      alt: '不是您所预期的？查看另外两个领域',
    },
    situations: {
      h2: '企业主为什么来找我们',
      lead: '不同的情形需要不同的对话。选择与您最接近的一项——它帮助我们路由您的咨询，而非替您做决定。',
      items: [
        { title: '增长资本', what: '用于扩张、产能或新地理区域的资金。', boundary: '我们评估增长是否可支撑，而不仅是其意图。' },
        { title: '产能 / 扩张', what: '新的能力、工厂或市场进入。', boundary: '取决于需求证据与执行风险。' },
        { title: '交接 / 部分退出', what: '所有权过渡或部分退出。', boundary: '我们不承诺估值或完成退出。' },
        { title: '战略合作伙伴', what: '共享的客户、项目或能力。', boundary: '非投资性协作经由联系渠道进行。' },
        { title: '数字化 / 运营改进', what: '系统、数据与流程变革。', boundary: '在证据到位之前，作为评估领域说明。' },
      ],
      continue: '继续此情形',
      note: '「其他或战略合作」是一般性对话，而非投资申请。',
    },
    governance: {
      h2: '结构与治理',
      lead: '我们持有多少、如何参与决策、停留多久——这些问题我们针对每个机会逐一回答，而非套用单一模板。',
      rows: [
        { theme: '所有权', preference: assumed('equity preference — minority / majority / control'), variable: '取决于情形与企业主的目标。' },
        { theme: '控制 / 治理', preference: assumed('board / key-decision participation'), variable: '在结构中约定，而非想当然。' },
        { theme: '时间跨度', preference: assumed('time horizon'), variable: '退出与流动性预期在开始时即已设定。' },
        { theme: '债务 / 股权', preference: assumed('structure preference'), variable: '在了解企业之后再选择。' },
      ],
      note: '我们仅在初步评估之后讨论适当的结构。我们并不暗示每种结构都适用于每家企业。',
    },
    value: {
      eyebrow: '超越资本',
      h2: '除了资金，我们还可能共同推进什么',
      lead: '只有当企业不断变强时，资本才有用。这些是我们考虑的领域——每一项都列出其输入、可能的行动以及我们如何衡量。',
      rows: [
        { topic: '增长系统', input: '销售管道、报价、重复业务。', action: '构建销售与交付流程。', measure: '赢单率、重复收入、交付利润率。' },
        { topic: '治理与数据', input: '报告、预算、控制。', action: '引入纪律化的报告机制。', measure: '按时报告、决策速度。' },
        { topic: '数字化 / 系统', input: '软件、数据、工作流。', action: '选择并落地契合目的的工具。', measure: '周期时间、错误率、数据可得性。' },
        { topic: '项目 / 渠道协同', input: '共享的客户与项目。', action: '把企业连接到相关机会上。', measure: '可转化的合格引荐。' },
        { topic: '人员与执行', input: '结构、招聘、交付。', action: '强化交付能力。', measure: '留存率、利用率、按时交付。' },
      ],
      note: '在证据到位之前，这些只是评估领域，而非已被证实的操作手册。任何外部专家或网络支持，都会披露其关系与授权。 ' + assumed('team history / output evidence per topic'),
      cta: '查看谁在做这项工作',
    },
    confidentiality: {
      h2: '我们如何处理敏感信息',
      lead: '在有必要之前，您不应交出敏感细节。我们分三层工作。',
      layers: [
        { title: '非敏感摘要', body: '企业做什么、规模多大，以及您正在考虑什么。足以作初步判断。' },
        { title: '双方一致后的细节', body: '财务、客户与合同——仅在双方同意且目的明确时共享。' },
        { title: '正式尽职调查', body: '完整的信息集，在需要时受保密协议约束。' },
      ],
      notFirstLead: '第一轮不需要：',
      notFirst: '客户名单、完整财务、员工数据、源代码或商业机密。',
      cta: '查看我们如何处理您的数据',
      note: '我们说明我们如何处理信息；我们并不在提交时自动提供保密协议。 ' + assumed('whether a standard NDA process exists'),
    },
    process: {
      h2: '首次接触之后会发生什么',
      lead: '一条逐步推进的路径，每一步都有您的输入与我们的判断。任何一方都可在任一阶段停止。',
      steps: [
        { title: '非敏感初步筛选', body: '您提供摘要；我们检查匹配度。' },
        { title: '管理层讨论', body: '我们讨论企业状况与您的目标。' },
        { title: '信息 / 商业审查', body: '我们按约定条款审查财务与运营。' },
        { title: '结构与治理', body: '我们讨论可能的参与形式。' },
        { title: '推进或停止', body: '进入协议，或停止并说明原因。' },
      ],
      note: '非投资性战略协作在初步筛选之后，转至我们的联系渠道。',
      cta: '查看共同方法',
    },
    faq: {
      h2: '企业主常问的问题',
      items: [
        { q: '你们会接管我的企业吗？', a: '默认不会。所有权与控制权针对每个机会单独约定——我们会告诉您我们能够工作的范围。 ' + assumed('control preference') },
        { q: '初次对话的保密程度如何？', a: '我们起初只索取非敏感摘要。细节随后在约定条款下共享。' },
        { q: '你们会支付顾问或经纪人的费用吗？', a: assumed('intermediary / commission policy') },
        { q: '这是贷款吗？', a: '不是。我们关注的是企业投资与合作伙伴机会，而非放贷。 ' + assumed('deal-type boundary') },
        { q: '如果我还未准备好出售，只是在探索呢？', a: '没关系。初次对话关乎匹配度，而非任何一方的承诺。' },
      ],
      cta: '提交业务机会',
      alt: '洽谈合作',
      siblings: [
        { label: '房地产开发', to: '/property-development' },
        { label: '创新与创投', to: '/innovation-ventures' },
      ],
    },
  },

  innovation: {
    meta: {
      title: '创新与创投 | Cyberate Investments',
      description:
        '我们在地产科技、建造科技、人工智能与可持续建造中寻找的创新主题、就绪度与证据——以及投资与试点之间的区别。',
    },
    hero: {
      eyebrow: '创新与创投',
      h1: '我们关注能解决可量化建成环境问题的创新。',
      lead:
        '如果您正在为建成环境开发技术或材料，我们从问题、部署场景以及真实使用中的证据入手。本页面说明我们考虑的主题、需要核实什么，以及投资与试点之间的区别。',
      kicker: '问题、部署场景与真实使用中的证据，排在技术本身之前。',
      boundary: '我们评估战略协作与精选机会。这是一个明确的重点——而非已有的创投组合，也不是对专有 AI 能力的主张。 ' + assumed('innovation pillar mandate, stage, geography'),
      cta: '提交创新机会',
      seeCriteria: '查看主题',
      roleNote: '本页任何内容都不构成投资、试点或客户的承诺。',
    },
    themes: {
      h2: '我们关心的主题',
      lead: '我们从真实问题出发，而非从技术出发。下面每个主题都列出问题、示例技术以及我们期望衡量的结果。',
      rows: [
        { problem: '成本与工期', tech: '规划与估算工具、进度分析。', result: '在真实项目上减少成本或工期超支。' },
        { problem: '质量与风险', tech: '检查、缺陷与合规工具。', result: '减少缺陷或返工，加快验收。' },
        { problem: '设计与规划', tech: '用于设计方案的生成式或仿真工具。', result: '更快、评估更充分的设计决策。' },
        { problem: '运营与维护', tech: '资产、能源与维护平台。', result: '降低运营成本或停机时间。' },
        { problem: '碳与材料', tech: '低碳材料、减少废弃物、追踪。', result: '可衡量的隐含碳或运营碳减排。' },
      ],
      exclude: '没有建成环境应用场景的通用 SaaS 不在范围内。 ' + assumed('exclusion list finalisation'),
    },
    notFit: {
      h2: '我们不关注什么',
      lead:
        '无论构建得多好，以下内容都不在范围内。现在就了解这一点，能为您省去一次推介。',
      items: [
        {
          title: '没有部署路径的想法',
          body: '一个我们无法想象它会在真实工地或真实企业内运行的概念，没有可供我们评估的东西。',
        },
        {
          title: '通用软件',
          body: '没有特定建成环境应用场景的工具，超出我们能够判断或帮助的范围。',
        },
        {
          title: '消费级应用',
          body: '我们读取的是建成环境的行业一侧，而非消费需求。',
        },
        {
          title: '投机性代币与金融产品',
          body: '完全在我们的范围之外，也在这家公司所做的事之外。',
        },
        {
          title: '没有任何支撑的能力主张',
          body: '如果核心主张无法被证明有效，就没有证据供门槛读取。我们也以同样的规则要求自己。',
        },
      ],
      boundary: assumed('exclusion list finalisation'),
      alt: '正在做邻近的事情？查看另外两个领域',
    },
    readiness: {
      h2: '您需要有多就绪？',
      lead: '针对投资与试点协作，我们接受不同阶段。下面每个层级展示所期望的证据，以及我们当前是否会考虑。',
      rows: [
        { stage: '问题与访谈', evidence: '已记录的问题、用户、支付意愿。', invest: '尚未', pilot: '视情况，用于验证' },
        { stage: '原型 / 技术验证', evidence: '可工作的原型、技术测试。', invest: '尚未', pilot: '视情况' },
        { stage: '带数据的试点', evidence: '来自真实工地或项目的部署结果。', invest: assumed('investment threshold'), pilot: '是' },
        { stage: '付费客户', evidence: '使用量、留存、单位经济模型。', invest: assumed('investment threshold'), pilot: '是' },
        { stage: '规模化', evidence: '可复制的交付与利润率证据。', invest: assumed('investment threshold'), pilot: '是' },
      ],
      note: '进入更高阶段并非自动发生。我们可能在任何节点停止，或让您回到更早的问题。',
      lens: '这个阶梯是我们解读就绪度的方式。它是我们自己的评估视角，而非行业标准——另一位投资者会画出不同的分界。',
    },
    validation: {
      eyebrow: '验证',
      h2: '一个好的演示，还不等于可部署的价值',
      lead: '我们评估问题、部署环境、集成、安全、采用、经济性与可扩展性。每项主张都需要来自产品预期工作场景的证据。',
      rows: [
        { dim: '问题强度', what: '该问题是否真实、高频且值得解决？', evidence: '客户访谈、购买意向。' },
        { dim: '部署环境', what: '它能否在真实工地而非沙盒中运行？', evidence: '试点结果、正常运行时间、集成说明。' },
        { dim: '集成', what: '它能否融入现有工作流与系统？', evidence: '集成、API 文档、用户采用。' },
        { dim: '安全 / 合规', what: '它是否符合适用标准与监管要求？', evidence: '认证、测试报告、审计。' },
        { dim: '采用者证据', what: '实际是谁在用，并且是否留存？', evidence: '使用数据、留存、引荐。' },
        { dim: '经济性', what: '它能否以可支撑的利润率节省成本或赚钱？', evidence: '单位经济模型、成本对比。' },
        { dim: '可扩展性', what: '它能否在不崩溃的情况下增长？', evidence: '架构、部署历史。' },
      ],
      lens: '这七个维度是我们自己的评估视角，而非已发布的标准。我们用它们来决定我们自身的参与，而非给市场打分。',
      ai: '对于基于 AI 的主张，我们会询问数据权利、偏差，以及可解释性或人工监督——而不只是准确率。',
      gateNote: '这一验证汇入每个机会都要通过的相同的六个门槛——包括阻止无法核实的数字或缺失依据的那一个。',
      gateLink: '查看共同门槛与停止条件',
    },
    pathways: {
      h2: '我们实际可能做什么',
      lead: '资本、试点与引荐是三种不同的承诺。下表展示目的、前提条件，以及我们不作承诺的事项。',
      rows: [
        { path: '投资', precondition: assumed('investment criteria and capital structure'), role: '评估后针对具体机会约定的资本。', notPromise: '估值、融资轮次或后续追加资金。' },
        { path: '试点 / 部署', precondition: '一个契合它的真实工地或项目。', role: '在约定范围内接入一次相关试验。', notPromise: '商业合同或全面铺开。' },
        { path: '战略协作', precondition: '超越单笔交易的共同价值。', role: '在明确的问题上共同推进。', notPromise: '排他性或承诺。' },
        { path: '引荐 / 网络', precondition: assumed('referrable parties and authorisation'), role: '在我们拥有授权关系之处作出引荐。', notPromise: '获得保证的客户或渠道。' },
      ],
      note: '我们不经由自身网络承诺客户、渠道或项目。任何引荐都仅在关系已获授权并已披露时作出。',
      cta: '查看角色如何界定',
    },
    materials: {
      h2: '首次提交应包含什么',
      lead: '一页摘要就足以启动。第一步请勿发送源代码、商业机密或客户数据。',
      minimum: ['问题以及谁拥有它', '产品及其运作方式', '阶段与证据（试点、使用、测试）', '团队与相关经验', '您想要什么'],
      minimumTitle: '最低要求',
      laterTitle: '可稍后提供',
      later: ['演示、数据室、引荐', '技术文档', '商业条款'],
      privacy: '先发送非敏感摘要。对于任何保密内容，我们会安排安全渠道。',
      cta: '提交摘要',
    },
    process: {
      h2: '提交之后会发生什么',
      lead: '先看相关性，再看证据，最后就是否试点或投资作出决定。',
      steps: [
        { title: '主题筛选', body: '我们检查问题与主题的匹配度。', io: '您提供摘要。' },
        { title: '证据审查', body: '我们审查试点、使用与测试。', io: '您提供证据并回答问题。' },
        { title: '技术 / 商业讨论', body: '我们讨论部署、集成与经济性。', io: '双方评估匹配度。' },
        { title: '路径决策', body: '投资、试点、协作或引荐——或者停止。', io: '基于证据决定。' },
      ],
      note: '我们不保证试点、出资或商业合同。我们就拒绝所给出反馈的深度，取决于我们的内部流程。 ' + assumed('feedback depth and recipient'),
      cta: '查看完整方法',
    },
    faq: {
      h2: '创始人常问的问题',
      items: [
        { q: '我需要分享源代码吗？', a: '不需要。先发送非敏感摘要。任何技术细节随后通过安全渠道共享。' },
        { q: '首次会面前你们会签保密协议吗？', a: '不会自动签。我们起初只索取非敏感摘要；在需要之处，可随后签订保密协议。 ' + assumed('NDA process') },
        { q: '你们只投 AI 吗？', a: '不是。我们关注任何能解决可量化建成环境问题的东西——软件、硬件或材料。' },
        { q: '你们能保证试点或客户吗？', a: '不能。试点取决于真实工地与匹配度；客户从来不会经由我们的网络得到保证。' },
        { q: '这是孵化加速器吗？', a: '不是。这是一次聚焦的投资与协作评估，而非批量项目。' },
      ],
      cta: '提交创新机会',
      alt: '洽谈合作',
      siblings: [
        { label: '房地产开发', to: '/property-development' },
        { label: '建成环境产业投资', to: '/built-environment-investments' },
      ],
    },
  },

  approach: {
    meta: {
      title: '我们如何投资 | Cyberate Investments',
      description:
        '我们的投资方法：我们经历的五个阶段、适用的门槛、扮演的角色，以及每项能力背后的证据——还有我们在何处停止。',
    },
    hero: {
      eyebrow: '我们如何投资',
      h1: '一套明确的方法，而非一串口号。',
      lead: '我们经历五个阶段——识别、投资、建设、扩张、实现。每个阶段都有明确的输入、要作出的决定、我们可能扮演的角色，以及清晰的停止理由。',
      kicker: '五个阶段。每个阶段都有输入、一项决定、我们可能扮演的角色，以及停止的理由。',
      stages: ['识别', '投资', '建设', '扩张', '实现'],
      boundary: '并非每个机会都会进入下一阶段，我们也不会在每个项目中承担所有角色。这套方法是我们自己的运营模式，而非对结果的保证。 ' + assumed('whether the method operates as an established capability'),
      cta: '提交机会',
      discuss: '洽谈合作',
    },
    gates: {
      h2: '每个机会都必须通过的门槛',
      lead: '这些门槛适用于地产、企业与创新。每个门槛都有一个通过信号与一个停止信号。',
      intro: '有一个门槛做得最多：证据质量。一项主张只有在有来源与日期支撑时才通过；当数字无法核实或依据缺失时，它就会停止。这一条规则贯穿每个阶段与每个领域。',
      emphasize: ['证据质量', '来源与日期', '依据缺失'],
      lens: '这六个门槛是我们自己的决策标准，而非行业标准。我们将它们公开，是为了让您在我们投入时间之前，就能看到一次评估会在何处停止。',
      rows: [
        { gate: '主题匹配', evidence: '契合某个已说明的领域及其标准。', stop: '超出我们已说明的重点或排除项。' },
        { gate: '证据质量', featured: true, evidence: '主张有来源与日期支撑。', stop: '数字无法核实或依据缺失。' },
        { gate: '角色匹配', evidence: '我们确实能够扮演的角色。', stop: '所需角色是我们无力承担的角色。' },
        { gate: '风险与合规', evidence: '风险已理解且在我们边界之内。', stop: '我们无法评估或接受的风险。' },
        { gate: '价值创造', evidence: '有一条我们能贡献价值的清晰路径。', stop: '没有现实的价值创造依据。' },
        { gate: '一致性', evidence: '共同目标与可执行的时间线。', stop: '目标或条款相互冲突。' },
      ],
      core: '核心门槛',
      links: [
        { label: '地产标准', to: '/property-development#property-fit' },
        { label: '业务标准', to: '/built-environment-investments#built-focus' },
        { label: '创新主题', to: '/innovation-ventures#innovation-themes' },
      ],
    },
    stages: {
      h2: '五个阶段',
      lead: '针对每个阶段：输入、关键判断、我们可能扮演的角色，以及继续或停止的条件。',
      items: [
        {
          name: '识别',
          input: '机会摘要——地点、阶段、证据，以及您想从我们这里得到什么。',
          judgement: '它是否契合某个领域并通过共同门槛？',
          role: '我们进行筛选并给出初步判断。',
          continue: '匹配度得到确认，且我们能看清路径。',
          stop: '主题、证据或角色匹配不成立。',
        },
        {
          name: '投资',
          input: '作出决定所需的细节——可行性、财务、计划、测试。',
          judgement: '这值得投入资本或正式角色吗？',
          role: '评估，以及在约定之处作出资本或参与决定。',
          note: '「投资」指的是决策节点——而非资本已经投入的承诺。',
          stop: '该案例经不起推敲。',
        },
        {
          name: '建设',
          input: '已约定的结构、计划与责任。',
          judgement: '我们能否交付所承诺的价值？',
          role: '针对该机会约定的角色——而非「我们包办一切」。',
          note: '「建设」指的是执行计划；它并不意味着 Cyberate 就是承建商。',
          stop: '交付风险或偏离计划的情况出现，且无法纠正。',
        },
        {
          name: '扩张',
          input: '模型有效且能增长的证据。',
          judgement: '增长是否可复制，并凭自身条件获得资金支撑？',
          role: '在契合我们所持角色之处提供支持。',
          note: '「扩张」并不保证增长。',
          stop: '扩张的依据无法被证明。',
        },
        {
          name: '实现',
          input: '已约定的退出、回报或完成路径。',
          judgement: '价值是否已实现，还是到了该持有或停止的时候？',
          role: '推进已约定的路径。',
          note: '「实现」并不保证退出或回报。 ' + assumed('Realise definition and meaning'),
          stop: '条件发生变化，已约定的路径不再适用。',
        },
      ],
      risk: '机会可能跳过、回到更早的阶段，或在任何节点停止。',
      riskLink: '风险纪律',
    },
    roles: {
      h2: '谁做什么',
      lead: '我们承担明确界定的角色；您以及（相关时）外部顾问承担其它角色。这张表防止对「一站式」的误读。',
      rows: [
        { party: 'Cyberate', responsible: '评估、约定的资本或角色、范围内的支持。', decisions: '关于我们自身参与的决定。', notResponsible: '我们未约定控制的结果。' },
        { party: '机会所有者', responsible: '信息、资产或企业、交付。', decisions: '关于资产或企业的决定。', notResponsible: '我们未约定要做的活儿。' },
        { party: '外部顾问', responsible: '法律、税务、技术或其它专业意见。', decisions: '其职责范围内的建议。', notResponsible: '属于各方的决定。' },
      ],
      note: '外部顾问与网络合作伙伴，仅在关系已获授权且已说明其类型时才会被提及。 ' + assumed('external network relationships'),
    },
    capabilities: {
      h2: '没有证据的能力，只是一个标签',
      lead: '我们通过五项能力来框定自己可能带来的东西：资本、专长、网络、技术与执行。针对每一项，我们都说明其行为、所需证据，以及我们不会作出的主张。',
      rows: [
        { cap: '资本', behaviour: '在任何东西被承诺之前，我们先说明参与的结构、来源与条款。', evidence: '我们资本的结构、来源与条款。', forbidden: '「AUM」「管理型基金」、公开募资。' },
        { cap: '专长', behaviour: '我们指出已作出的评估与决定，以及我们在其中扮演的角色。', evidence: '团队履历、项目角色、成果。', forbidden: '没有记录的「多年经验」。' },
        { cap: '网络', behaviour: '我们仅在关系已获授权时点名，并说明其类型。', evidence: '经许可的具名关系。', forbidden: 'Logo 墙、未分类的合作关系。' },
        { cap: '技术', behaviour: '我们让每个机会都经过相同的输入——每个都带来源与日期，经受压力检验。', evidence: '真实的模型、方法、成果——正是门槛所要求的带来源与日期、经压力检验的输入。', forbidden: '未经演示的「AI 驱动」「专有数据」。' },
        { cap: '执行', behaviour: '我们在约定范围内承担明确界定的责任，并说明它止于何处。', evidence: '角色与项目事实，附带范围。', forbidden: '「一站式」「全包保证」。' },
      ],
      pendingChip: '证据待核实',
      note: '证据状态按能力标注为「已确认」或「待定」。目前大多数能力处于待定： ' + assumed('publicly available evidence for each capability'),
      cta: '查看团队',
      gateLink: '查看共同门槛与停止条件',
    },
    risk: {
      eyebrow: '风险纪律',
      h2: '我们如何处理风险与冲突',
      lead: '我们把风险当作决策的一部分，而非其脚注。',
      rows: [
        { risk: '规划 / 监管', control: assumed('control approach'), escalate: '未解决的规划风险会终止评估。' },
        { risk: '市场', control: '带来源与日期的市场证据。', escalate: '缺乏支撑的需求假设会终止该案例。' },
        { risk: '交付', control: '能力与进度计划审查。', escalate: '无法管理的交付风险会终止承诺。' },
        { risk: '财务', control: '可行性与压力测试。', escalate: '案例在压力下站不住脚 → 停止。' },
        { risk: '冲突 / 关联方', control: '披露关系与利益。', escalate: assumed('conflict policy and approval authority') },
      ],
      principle: '我们披露可能影响决策的关系与利益，我们不会把一笔交易凌驾于一个明确的冲突之上。 ' + assumed('governance / conflict policy finalisation'),
      link: '阅读完整边界',
    },
    faq: {
      h2: '合作伙伴常问的问题',
      lead: '对首次对话之前常出现的问题的简短回答。',
      items: [
        {
          q: '到底是谁在做决定？',
          a: '我们只决定我们自身的参与。关于资产或企业的决定，属于拥有它的那一方——这一划分在开始任何工作之前，就已在上面的角色表中写明。',
        },
        {
          q: '什么会让评估最快停止？',
          a: '一个没有人能给出来源的数字。证据门槛在数字无法核实或依据缺失时停止，而且它比任何其它门槛都更早停止，因为下游一切都依赖它。',
        },
        {
          q: '你们会告诉我们为什么放弃吗？',
          a: '我们力求在我们评估的层面给出原因。对于我们已经拒绝的机会，我们不会提供详细的技术、法律或投资建议。',
        },
        {
          q: '如果你们在两边都有利益呢？',
          a: '我们会披露该利益，存在冲突的人退出决策，批准交由一位无冲突的董事。这条规则是公开的，而非逐案处理。',
        },
        {
          q: '被评估需要我们付费吗？',
          a: '不需要。费用与商业条款针对每次合作单独约定，而初步判断不附带任何费用。',
        },
        {
          q: '机会能在各阶段之间倒退吗？',
          a: '能。机会可以跳过一个阶段、回到更早的阶段，或在任何节点停止。这些阶段描述的是一连串决策，而非传送带。',
        },
        {
          q: '这套方法已有多少投入实际使用？',
          a: assumed('whether the method operates as an established capability'),
        },
      ],
      cta: '提交机会',
      alt: '洽谈合作',
    },
    byPillar: {
      h2: '同一套方法，不同地应用',
      lead: '五个阶段是共用的；变化的是主要输入、关键风险，以及我们聚焦的价值。',
      columns: [
        {
          pillar: '房地产开发',
          input: '地块、产权、规划、可行性。',
          risk: '规划与交付。',
          value: '让项目建成并实现价值。',
          material: '地点、阶段、用途、规模。',
          to: '/property-development',
          cta: '查看地产标准',
        },
        {
          pillar: '建成环境产业投资',
          input: '企业业绩、客户、人员。',
          risk: '集中度与关键人。',
          value: '运营与增长系统。',
          material: '子行业、阶段、所有权、动机。',
          to: '/built-environment-investments',
          cta: '查看业务标准',
        },
        {
          pillar: '创新与创投',
          input: '问题、证据、部署。',
          risk: '真实世界的部署与采用。',
          value: '验证与商业化。',
          material: '问题、产品、阶段、证据。',
          to: '/innovation-ventures',
          cta: '查看创新主题',
        },
      ],
    },
    finalCta: {
      h2: '两条前进之路',
      body: '有具体机会？提交它。想先进行一般或战略性的对话？联系我们。',
      discuss: '洽谈合作',
      privacy: '我们只收集首次评估所需的信息。',
    },
  },

  about: {
    meta: {
      title: '关于我们 | Cyberate Investments',
      description:
        'Cyberate Investments 是谁——我们的阿德莱德基地、公司信息、团队，以及我们与合作伙伴协作方式背后的原则与边界。',
    },
    hero: {
      eyebrow: '关于我们',
      h1: 'Cyberate Investments 是一家位于阿德莱德的开发与投资公司。',
      kicker: '核实我们是谁、谁在做这项工作，以及我们运作的边界。',
      lead: '我们专注于地产、建成环境企业与推动创新。本页面是您可以核实我们是谁、谁在做这项工作，以及我们运作边界的地方。',
      boundary: '公司注册信息以及任何牌照或授权状态，均列于下方，并在发布前核实。 ' + assumed('final company category and geography'),
      cta: '查看公司信息',
    },
    entity: {
      h2: '公司信息',
      lead: '您正在打交道的实体，以及在哪里可以核实它。',
      fields: [
        { label: '法定名称', value: entity.name },
        { label: 'ABN', value: entity.abn },
        { label: 'ACN', value: entity.acn },
        { label: '主要营业地点', value: assumed('principal place of business') },
        { label: '注册办公地址', value: assumed('registered office') },
        { label: '地址（对外公布）', value: entity.address },
        { label: '电话', value: entity.phone },
        { label: '邮箱', value: entity.email },
        { label: '牌照 / 授权', value: assumed('AFS licence / authorised representative / exemption / not conducting licensable activity — precise wording') },
        { label: '最近核实时间', value: assumed('verification date') },
      ],
      register: assumed('ASIC / ABR official register link'),
      boundary: '我们不掩盖自己的 AFS 状态。在适用豁免或无需持牌的情形之处，我们使用经法律认可措辞。',
    },
    story: {
      h2: '为什么是建成环境——以及为什么是这三个领域',
      body: '地产、运营企业与推动创新，以不同方式塑造建成环境，但决策是相通的。我们把资本、真实世界的执行与长期价值放在一起评估。正因如此，我们专注于那些我们的判断与一个约定角色能够共同导向同一结果的机会。',
      milestones: assumed('verifiable company milestones and sources'),
    },
    principles: {
      eyebrow: '我们如何协作',
      h2: '决策中看得见的纪律',
      lead: '每项原则都配有一个您可以预期的行为。',
      items: [
        { title: '先标准，后热情', body: '在讨论潜在价值之前，我们先说明标准、证据与风险。' },
        { title: '运营者视角', body: '我们以阶段、结构与责任来工作，每个节点都有明确的决定。' },
        { title: '证据胜于形容词', body: '我们让主张保持简短，并把来源、依据或边界放在它们旁边。' },
        { title: '面向未来，而非追逐潮流', body: '只有当技术改变了成本、时间、质量、风险或可量化的建成环境结果时，它才重要。' },
        { title: '本地且开放', body: '阿德莱德与南澳大利亚优先。只有当有证据支撑时，我们才描述更广的覆盖范围。' },
      ],
      cta: '查看我们的风险纪律',
    },
    team: {
      h2: '团队',
      lead: 'Cyberate Investments 目前对外介绍的、支持评估、运营、业务拓展与市场沟通的人员。详细的资质与项目记录，可在直接尽职调查中核实。',
      members: [
        { name: 'William Jiang', role: 'Managing Director & Data Scientist', history: '主导投资评估，并为地产与商业决策带来数据驱动的方法。', verify: assumed('LinkedIn / professional registration') },
        { name: 'Jax Jin', role: 'Director & Chief Operating Officer, DDDI Group', history: '支持集团运营、商业协调，以及跨职能机会的执行。', verify: assumed('LinkedIn / professional registration') },
        { name: 'Gary Gao', role: 'Business Development Manager', history: '支持机会来源、关系拓展与早期商业讨论。', verify: assumed('LinkedIn / professional registration') },
        { name: 'Lin Yuan', role: 'Marketing Manager', history: '支持市场沟通、利益相关方材料，以及投资主题的呈现。', verify: assumed('LinkedIn / professional registration') },
      ],
      fallback: '团队信息可在直接讨论中获取。',
      capabilitiesLink: '查看我们如何框定能力',
    },
    disclosure: {
      eyebrow: '我们公开什么',
      h2: '在证据尚未到位之处，我们如实说明',
      lead:
        '一家年轻的公司可以填补缺口，也可以把它们标注出来。我们选择标注。这是我们把应用到机会上的同一纪律，反过来用在自己身上。',
      rows: [
        {
          practice: '能力附带证据状态',
          detail: '五项能力中的每一项，都公布其背后的证据，并标注为已确认或待定。其中有几项处于待定，它们都如实说明。',
        },
        {
          practice: '每项能力都点名自己不会作出的主张',
          detail: '在每项能力旁边，是我们不会就它作出的主张——包括我们本可使用、却选择不用的技术措辞。',
        },
        {
          practice: '团队细节按需核实，而非在此断言',
          detail: '我们公布姓名与当前职务。资质与项目记录在直接尽职调查中确认，而非在此用形容词描述。',
        },
        {
          practice: '标准在敲定之前只是工作口径',
          detail: '本网站上的门槛与边界，是我们正在执行的工作口径。在某项仍未敲定之处，它会被表述为工作口径，而非规则。',
        },
        {
          practice: '没有案例、数字或客户姓名',
          detail: '本网站上没有这些。不是因为无话可说，而是因为未经许可与来源，这里不会发布任何内容。',
        },
      ],
      note:
        '这是网站上最可能发生变化的部分。当证据得到确认，它就会取代标注——而标注不会悄悄消失。',
      cta: '查看能力如何被佐证',
    },
    relationships: {
      h2: '关系与边界',
      contracting:
        '任何合作都与相关协议中所指定的实体签约。除非该协议如此规定，否则不推定任何其它实体对此负责。',
      note:
        '当一个更广的集团或顾问关系与某个机会相关时，我们会在其适用的节点说明它及其类型，而非在此泛泛而谈。',
      pending: assumed('DDDI entity relationships, brand rights and responsibility boundaries'),
    },
    contactCta: {
      h2: '先核实，再与我们交谈',
      cta: '洽谈合作',
      submit: '提交机会',
      privacy: '隐私政策',
      terms: '条款与条件',
    },
  },

  contact: {
    meta: {
      title: '联系我们 | Cyberate Investments',
      description:
        '在阿德莱德联系 Cyberate Investments——电话、邮箱、办公地址，以及用于一般咨询的简短表单。对于具体机会，请使用我们的提交页面。',
    },
    hero: {
      eyebrow: '联系我们',
      h1: '告诉我们您需要什么，我们会为您路由。',
      kicker: '一般性问题，或具体机会——选对路径即可。',
      lead: '两条进入路径：一般性问题，或具体机会。选对路径，意味着您的信息第一次就能到达合适的人。',
      general: '有一般性问题',
      generalCta: '查看联系方式',
      opportunity: '有具体机会？',
      opportunityCta: '提交机会',
    },
    channels: {
      h2: '联系方式',
      lead: '使用契合您目的的渠道。',
      rows: [
        { channel: '电话', value: entity.phone, use: '时间敏感或直接的问题。', href: entity.phoneHref },
        { channel: '邮箱', value: entity.email, use: '书面咨询与文件。', href: entity.emailHref },
        { channel: '地址', value: entity.address, use: '邮寄与来访。' },
        { channel: '实体', value: entity.name, use: '正式往来函件。' },
      ],
      hours: assumed('business hours and appointment requirements'),
      verify: '核实公司信息',
    },
    location: {
      h2: '找到我们',
      visit: assumed('whether walk-ins are accepted or by appointment only'),
      mapAlt: '到 5/15 Field St, Adelaide SA 5000 的地图',
      openMaps: '在地图中打开',
      mapsUrl: 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent('5/15 Field St, Adelaide SA 5000'),
      accessibility: assumed('accessibility and parking information'),
    },
    expect: {
      eyebrow: '在您联系我们之后',
      h2: '接下来会按顺序发生什么',
      lead:
        '我们描述的是流程顺序，而非回复时限。当我们能就时限作出承诺时，我们会公布一个；在那之前，我们宁可准确地描述步骤。',
      steps: [
        { title: '它到达某个人', body: '信息到达团队，而非进入自动队列。接手的人会在回复前阅读它。' },
        { title: '我们确定该由谁回答', body: '关于地块、企业与技术的问题，会转给不同的人。这正是主题字段的用途。' },
        { title: '我们通过您选择的渠道回复', body: '除非您要求我们致电，否则通过邮件回复。如果答案是否定的，您会得到我们评估层面的原因。' },
        { title: '如果它演变为一个机会', body: '我们会把您转到提交流程，让首次评估从我们向所有人索取的同套信息开始。' },
      ],
      boundary:
        '联系不会让任何一方承担任何义务。它是一场对话，而非一次提交；在您要求我们评估之前，不会有任何内容被评估。',
      cta: '查看评估方法',
    },
    faq: {
      h2: '在您联系我们之前',
      lead: '我们在这个节点最常被问到的问题。',
      items: [
        {
          q: '我该用这个表单还是提交表单？',
          a: '如果有一个您希望被评估的具体地块、企业或技术，提交表单更快——它会提前索取我们所需的内容。其余一切都归到这里。',
        },
        {
          q: '我可以直接发送文件吗？',
          a: '请勿直接发送。先发送一段简短的非敏感描述。如果需要细节，我们会为它安排一个受控渠道。',
        },
        {
          q: '交谈前你们会签保密协议吗？',
          a: '通常不会，因为初次对话并不需要保密信息。在需要之处，可在任何详细尽职调查之前签订。',
        },
        {
          q: '我不在南澳大利亚，值得联系你们吗？',
          a: '对于地产，南澳大利亚是重点。对于企业与创新，地域范围更广——那些页面上的标准，会比一通电话更能说明问题。',
        },
        {
          q: '我可以到访办公室吗？',
          a: assumed('whether walk-ins are accepted or by appointment only'),
        },
        {
          q: '谁会看到我发送的内容？',
          a: '为回答您而需要阅读它的人。我们如何处理个人信息，详见我们的隐私政策。',
        },
      ],
      privacyLink: '阅读隐私政策',
    },
    form: {
      h2: '发送消息',
      lead: '用于一般咨询的简短表单。请勿在此发送敏感的机会细节——请改用提交页面。',
      fields: {
        name: { label: '全名', help: '您的姓名，以及您希望我们如何称呼您。', error: '请输入您的全名。' },
        email: { label: '邮箱', help: '我们会回复到这个地址。', error: '请输入有效的邮箱地址。' },
        topic: { label: '主题', help: '帮助路由您的消息。', error: '请选择主题。' },
        phone: { label: '电话（选填）', help: assumed('whether phone is collected'), error: '请输入有效的电话号码。' },
        message: { label: '您的消息', help: '几句话就足够了。', error: '请告诉我们如何帮到您。' },
      },
      topics: [
        { value: 'general', label: '一般咨询' },
        { value: 'partnership', label: '合作洽谈' },
        { value: 'media', label: '媒体' },
        { value: 'supplier', label: '供应商' },
        { value: 'other', label: '其它' },
      ],
      consent: '我同意 Cyberate Investments 按隐私政策所述处理我的信息。',
      submit: '发送消息',
      sending: '发送中…',
      sensitive: '请勿在此表单中包含敏感或保密材料。',
      errorSummary: '请修正高亮的字段后重试。',
      serviceError: '我们无法发送您的消息。请重试，或致电 +61 8 7110 0111。',
      captchaExpired: '安全校验已过期。请重新完成——您的消息仍被保留。',
      topicToOpportunity: '这听起来像一个具体机会。不妨使用我们的提交表单，它只索取我们所需的内容。',
    },
    after: {
      successTitle: '消息已发送',
      successBody: '感谢——我们已收到您的消息。我们会回复到您提供的地址。 ' + assumed('response method and timing; no SLA unless confirmed'),
      reference: '您的参考编号：',
      next: '等待期间，您可以查看我们的投资方法。',
      call: '更希望致电？',
      submitLink: '需要提交机会吗？',
    },
  },

  submit: {
    meta: {
      title: '提交机会 | Cyberate Investments',
      description:
        '向 Cyberate Investments 提交地产、企业、创新或合作机会。我们只索取首次评估所需的信息。',
    },
    intro: {
      eyebrow: '提交机会',
      h1: '告诉我们您的机会。',
      kicker: '一份简短摘要就够作首次阅读。这不是数据室。',
      lead: '本表单用于具体的地产、企业、创新或合作机会。先从一个简短摘要开始：它是什么、进展到哪一步、可得的证据，以及您希望我们考虑的角色。这就足以作首次评估；它不是数据室。',
      notes: [
        { title: '仅限初步筛选', body: '提交是请求初步判断，而非出资申请。' },
        { title: '双方均无承诺', body: '我们可能会索取更多细节或停止；您也同样可以。' },
        { title: '最少信息', body: '我们收集最少必要信息。请勿在此发送敏感或保密材料。' },
      ],
      overview: '类型 → 您的信息 → 机会摘要 → 支持材料（选填）→ 审阅并提交',
      general: '这不是一个具体机会？改为联系我们。',
      sensitive: '请勿在这一步提交敏感或保密材料。',
    },
    steps: ['类型', '您的信息', '摘要', '材料', '审阅'],
    type: {
      h2: '这是什么类型的机会？',
      lead: '选择最接近的匹配项。您可以稍后更改。',
      options: [
        { value: 'property', title: '地产机会', example: '一个地块或开发项目。', summary: '地点、阶段、用途、规模。' },
        { value: 'business', title: '建成环境企业', example: '一家建筑、工程、设计、供应链或服务企业。', summary: '子行业、阶段、所有权、动机。' },
        { value: 'innovation', title: '创新或创投', example: '一项技术、产品或项目。', summary: '问题、产品、阶段、证据。' },
        { value: 'partnership', title: '战略合作', example: '一项协作或联合提案。', summary: '双方的价值与提案。' },
        { value: 'other', title: '其它', example: '以上皆非。', summary: '转至一般联系。' },
      ],
      notSure: '不确定？查看标准',
      criteria: {
        property: '地产',
        business: '企业',
        innovation: '创新',
      },
      error: '请选择机会类型以继续。',
      continue: '继续',
    },
    contact: {
      h2: '谁在提交这个？',
      lead: '我们需要知道我们在与谁对话，以及您能代表这个机会发言。',
      fields: {
        name: { label: '全名', help: '您的姓名。', error: '请输入您的全名。' },
        email: { label: '工作邮箱', help: '我们会回复到这里。', error: '请输入有效的邮箱地址。' },
        phone: { label: '电话', help: assumed('whether required'), error: '请输入有效的电话号码。' },
        organisation: { label: '机构', help: '您的公司或实体（如有）。' },
        role: { label: '您的角色', help: '例如：所有者、董事、顾问。' },
        relationship: { label: '您与该机会的关系', help: '所有者 / 授权代表 / 顾问', error: '请告诉我们您与该机会的关系。' },
        preferred: { label: '偏好联系方式', help: '邮箱 / 电话', error: '请选择您偏好的联系方式。' },
      },
      relationshipOptions: ['所有者', '授权代表', '顾问'],
      preferredOptions: ['邮箱', '电话'],
      adviserNote: '如果您是顾问或代理人，请确认您经授权可代表所有者讨论此机会。',
      back: '返回',
      continue: '继续',
    },
    details: {
      h2: '一段简短摘要',
      summary: { label: '一句话摘要', help: '这个机会是什么，用一句话概括。', error: '请写一句话摘要。' },
      location: { label: '地点 / 市场', help: '它在何处。' },
      stage: { label: '阶段', help: '它进展到哪一步。' },
      seeking: { label: '您想从我们这里得到什么', help: '资本、共同投资、评估、协作。' },
      unknown: '尚不清楚',
      hint: '摘要可以很短——几句话就足够。',
      back: '返回',
      continue: '继续',
    },
    materials: {
      h2: '支持材料（选填）',
      lead: '附件能帮助我们更快评估，但对首次判断而言并非必需。',
      examples: '场地平面图、可行性摘要、业务摘要、试点结果，或链接。',
      limit: assumed('allowed formats and size limits, upload storage and access control'),
      warning: '请勿附加身份证明文件、客户数据、源代码或商业机密。先发送非敏感摘要；对于任何保密内容，我们会安排安全渠道。',
      skip: '暂时跳过——您可以稍后提供更多信息。',
      linksLabel: '链接或文件（URL 或简短描述）',
      linkPlaceholder: '例如：一个共享链接或一句描述',
      back: '返回',
      continue: '继续',
    },
    review: {
      h2: '审阅并提交',
      edit: '编辑',
      confirm1: '我确认我有权分享此信息，且据我所知它是准确的。',
      confirm2: '我同意 Cyberate Investments 按隐私政策所述处理我的信息。',
      noNda: '提交并不构成保密协议、要约，或任何一方继续推进的义务。',
      marketing: '通过邮件向我发送 Cyberate 更新（选填）。',
      captcha: '完成安全校验。',
      captchaExpired: '安全校验已过期——请重新完成。您的信息仍被保留。',
      submit: '提交机会',
      submitting: '提交中…',
      error: '提交前，您需要确认上述声明。',
      back: '返回',
    },
    result: {
      successTitle: '机会已提交',
      successBody: '我们已收到您的摘要。我们会审阅它，并回复到您提供的地址。 ' + assumed('response timing and owner'),
      reference: '您的参考编号：',
      next: '等待期间，请查看我们的方法。',
      fail: '我们无法提交您的机会。请重试。',
      unknown: '我们无法确认它是否已被收到。请稍候再重新提交，或致电 +61 8 7110 0111。',
      call: '更希望交谈？',
      email: '邮箱',
      retry: '重试',
    },
  },

  privacy: {
    meta: {
      title: '隐私政策 | Cyberate Investments',
      description:
        'Cyberate Investments 如何收集、使用、披露、保留与保护个人信息，以及您如何访问、更正或删除它。',
    },
    header: {
      eyebrow: '隐私政策',
      h1: '隐私政策',
      controller: entity.name + ' ' + assumed('data controller and ABN/ACN'),
      updated: '最近更新：' + assumed('date'),
      scope: '适用于本网站、我们的联系与提交表单，以及相关的邮件与线下互动。',
      summary: '简而言之：我们只收集为回复您或评估机会所需的信息，我们只在下方所述之处共享它，且您可以要求访问或更正它。完整政策如下。',
      notice: '本页面是隐私披露框架，不能替代法律审查。 ' + assumed('legal review and finalisation'),
    },
    collection: {
      h2: '我们收集什么，以及它从何而来',
      rows: [
        { scenario: '浏览', data: assumed('log / analytics data (if any)'), source: assumed('source'), required: assumed('required') },
        { scenario: '一般联系', data: '姓名、邮箱、主题、消息（如收集则含电话）。', source: '联系表单。', required: '姓名、邮箱、消息。' },
        { scenario: '机会提交', data: '姓名、联系方式、关系、机会摘要、选填材料。', source: '提交表单。', required: '表单中已标注。' },
        { scenario: '文件与往来函件', data: '附件与后续邮件。', source: '安全渠道。', required: '视需要。' },
      ],
      sensitive: '如果您发送了我们并未索取的信息，我们将仅在回复所需范围内处理它，并在能够之处删除它。 ' + assumed('handling approach'),
    },
    use: {
      h2: '我们为什么使用您的信息',
      rows: [
        { purpose: '回复咨询', data: '联系方式与消息。', basis: assumed('legal basis'), consequence: '我们无法回复。' },
        { purpose: '评估机会', data: '摘要与材料。', basis: assumed('legal basis'), consequence: '我们无法评估。' },
      ],
      marketing: '除非您另行选择加入，否则我们不会发送营销通信。对于任何关于您的重大决定，我们不会使用自动化决策。 ' + assumed('whether accurate'),
    },
    disclosure: {
      h2: '我们与谁共享信息',
      rows: [
        { recipient: assumed('email / hosting / form provider'), purpose: '提供服务。', data: assumed('data'), location: assumed('cross-border'), safeguard: assumed('safeguards') },
        { recipient: assumed('captcha provider'), purpose: '安全校验。', data: assumed('data'), location: assumed('cross-border'), safeguard: assumed('safeguards') },
        { recipient: '关联实体 / 顾问', purpose: '在已披露且必要时。', data: assumed('data'), location: assumed('cross-border'), safeguard: assumed('safeguards') },
        { recipient: '法律 / 监管', purpose: '在法律要求时。', data: assumed('data'), location: assumed('cross-border'), safeguard: assumed('safeguards') },
      ],
      note: '跨境披露在确认之前是一项发布阻断项。',
    },
    retention: {
      h2: '我们保留信息多久，以及如何保护它',
      rows: [
        { type: '咨询', term: assumed('period or decision criteria') },
        { type: '机会提交', term: assumed('period') },
        { type: '上传文件', term: assumed('period') },
      ],
      security: '我们实施访问控制，限制谁能看到信息，并使用安全渠道处理文件。没有任何传输方式是绝对安全的。 ' + assumed('actual organisational / technical measures'),
      incident: '如果发生影响您信息的事件，我们将按需通知您。',
    },
    rights: {
      h2: '您的权利与选择',
      rows: [
        { right: '访问', how: '通过邮件提出您的请求。', limit: '我们会先核实身份。' },
        { right: '更正', how: '告诉我们修改什么。', limit: '—' },
        { right: '删除', how: '在能够之处要求我们删除。', limit: '法律留存义务可能仍适用。' },
        { right: '退出营销', how: '使用退订链接。', limit: '服务性消息仍适用。' },
      ],
    },
    cookies: {
      h2: 'Cookie、分析与外部链接',
      note: assumed('cookie / storage categories from an actual scan'),
      external: '指向外部网站的链接受其自身政策约束；我们不对它们如何处理您的信息负责。',
    },
    contact: {
      h2: '联系、投诉与变更',
      enquiries: '隐私咨询： ' + assumed('dedicated mailbox or contact person'),
      complaints: assumed('internal complaint process and applicable regulator (e.g. OAIC)'),
      updates: '我们可能会更新本政策。顶部的「最近更新」日期显示它何时发生变化。',
      cta: '联系我们',
    },
  },

  terms: {
    meta: {
      title: '条款与条件 | Cyberate Investments',
      description:
        '约束您使用 Cyberate Investments 网站的条款，包括一般信息与金融建议之间的边界，以及责任。',
    },
    header: {
      eyebrow: '条款与条件',
      h1: '条款与条件',
      entity: entity.name + ' ' + assumed('ABN/ACN'),
      effective: '生效日期：' + assumed('date'),
      scope: '这些条款约束您对本网站的使用。',
      acceptance: '使用本网站即表示您接受这些条款。 ' + assumed('acceptance mechanism consistent with the actual UI'),
      notice: '本页面是条款框架，不能替代法律审查。 ' + assumed('legal review and finalisation'),
    },
    siteUse: {
      h2: '使用本网站',
      allowed: '您可以出于自身信息目的浏览本网站，并在提供之处使用我们的表单联系我们或提交机会。',
      prohibited: '您不得滥用本网站、干扰其运行、试图绕过安全机制、将其用于非法目的，或以扰乱服务的方式自动化访问。',
      availability: '我们力求保持网站可用，但不保证访问不中断。',
    },
    boundary: {
      h2: '重要：一般信息，而非金融建议',
      conclusion:
        '本网站的任何内容均不构成金融产品建议、推荐、获取任何金融产品的要约或邀请，也不构成对任何回报或结果的承诺。我们描述我们专注的机会以及我们可能扮演的角色。参与、资本、结构与条款仅在评估之后、并在必要时经法律与监管审查后，针对具体机会约定。',
      licence: 'Cyberate Investments Pty Ltd ' + assumed('licence / authorisation / exemption / non-licensable activity — precise statement') + '。',
      supplement: '我们不面向公众募资，也不向零售客户提供个人金融建议。',
      riskLink: '查看我们如何处理风险',
    },
    infoRisk: {
      h2: '信息、变更与风险',
      points: [
        '信息按其所载明的日期提供，并可能发生变化。',
        '任何数字都标明其范围、依据、期间与来源；请核实后再依赖它。',
        '前瞻性陈述是估计，而非保证。',
        '历史表现不保证未来结果。',
        '地产、企业与创新机会均附带风险，包括资本损失；您应获取自己的建议。',
      ],
    },
    submissions: {
      h2: '提交',
      points: [
        '您声明您有权分享您提交的内容，且据您所知它是准确的。',
        '除非我们另行单独签署，否则提交信息并不构成保密协议。',
        '提交并不构成投资、顾问或代理关系。',
        '提交并不使我们有义务以任何特定方式审查、推进或回复。',
        '第一步请勿提交敏感、第三方或保密材料。',
      ],
      warning: '提交并不形成保密协议。也不产生推进的义务。',
      privacyLink: '我们如何处理您的信息',
    },
    intellectualProperty: {
      h2: '知识产权',
      site: '本网站上的所有内容——文字、图形、Logo 与版式——均由 Cyberate Investments 拥有或获其授权，除非另有说明。 ' + assumed('actual asset rights'),
      licence: '您可为个人、非商业性参考目的查看与打印内容。除此之外，您不得复制或分发它。',
      thirdParty: '第三方名称与标识归其所有者所有。',
      submitted: '您保留您所提交内容的所有权；通过提交，您授予我们一项有限权利，用它来评估并回复您的机会。 ' + assumed('licence scope confirmed by counsel'),
    },
    thirdParties: {
      h2: '第三方链接与服务',
      points: [
        '外部链接仅为方便而提供；我们并不控制它们，也不对其内容或隐私实践负责。',
        '一个链接或提及本身并不意味着背书或合作关系。',
        '在存在关系之处，会连同其类型一并说明。',
      ],
    },
    liability: {
      h2: '保证与责任',
      points: [
        '在法律允许的范围内，本网站按现状提供，不附带保证。',
        '在法律允许的范围内，Cyberate Investments 不对因使用或依赖本网站而产生的损失承担责任。',
        '这些条款中的任何内容，都不排除法律所不能排除的您的权利。',
      ],
    },
    lawContact: {
      h2: '管辖法律、变更与联系',
      law: '这些条款受澳大利亚南澳大利亚州法律管辖。 ' + assumed('governing law confirmation'),
      updates: '我们可能会更新这些条款。顶部的生效日期显示它们何时发生变化。',
      contact: '关于这些条款的问题： ' + entity.email,
      severability: '如果任何条款不可执行，其余部分继续有效。',
    },
  },

  notfound: {
    meta: {
      title: '页面未找到 | Cyberate Investments',
      description: '您要查找的页面未能找到。返回 Cyberate Investments 首页，或浏览我们的投资领域。',
    },
    eyebrow: '404',
    h1: '页面未找到',
    body: '您要查找的页面可能已移动，或者地址有误。',
    cta: '返回首页',
    services: '在找我们的服务？它们现在位于「我们如何投资」之下。',
    links: [
      { label: '房地产开发', to: '/property-development' },
      { label: '建成环境产业投资', to: '/built-environment-investments' },
      { label: '创新与创投', to: '/innovation-ventures' },
      { label: '我们如何投资', to: '/approach' },
      { label: '关于我们', to: '/about' },
      { label: '联系我们', to: '/contact' },
    ],
    help: {
      h2: '还是找不到？',
      body: '如果您是循着一个链接来到这里，请告诉我们——或者，如果您有具体机会，请直接提交。',
      contact: '联系我们',
      submit: '提交机会',
      warning: '请勿在本页面输入敏感信息。',
    },
  },

  breadcrumb: {
    home: '首页',
  },
};

export default zh;
